export default "__VITE_ASSET__Cvlw2Dr2__"